export const VALID_ASSET_TYPES = [
    "screenshot",
    "video",
    "trace",
    "lighthouse",
];
export const BYTES_DIVISOR = { KB: 1024, MB: Math.pow(1024, 2) };
//# sourceMappingURL=onTestEnd.js.map